import { useState, useCallback } from 'react';
import { usuariosAPI } from '../../../core/api/api';

export const useUsuarios = () => {
  const [usuarios, setUsuarios] = useState([]);
  const [roles, setRoles] = useState([]);
  const [loading, setLoading] = useState(false);

  const cargarRoles = useCallback(async () => {
    const res = await usuariosAPI.getRoles();
    setRoles(res.data || []);
  }, []);

  const buscar = useCallback(async (usuario, idRol) => {
    setLoading(true);
    try {
      const res = await usuariosAPI.getUsuarios(usuario, idRol);
      const data = res.data || [];
      setUsuarios([...data].sort((a, b) => {
        const activoA = parseInt(a.activo ?? a.Activo ?? '1');
        const activoB = parseInt(b.activo ?? b.Activo ?? '1');
        if (activoB !== activoA) return activoB - activoA; // habilitados primero
        const nameA = (a.usuario ?? a.Usuario ?? '').toLowerCase();
        const nameB = (b.usuario ?? b.Usuario ?? '').toLowerCase();
        return nameA.localeCompare(nameB);
      }));
    } finally {
      setLoading(false);
    }
  }, []);

  const guardar = useCallback(async (data) => {
    setLoading(true);
    try { await usuariosAPI.guardar(data); }
    finally { setLoading(false); }
  }, []);

  const actualizar = useCallback(async (id, data) => {
    setLoading(true);
    try { await usuariosAPI.actualizar(id, data); }
    finally { setLoading(false); }
  }, []);

  const cambiarEstado = useCallback(async (id, activo) => {
    setLoading(true);
    try { await usuariosAPI.cambiarEstado(id, activo); }
    finally { setLoading(false); }
  }, []);

  const eliminar = useCallback(async (id) => {
    setLoading(true);
    try { await usuariosAPI.eliminar(id); }
    finally { setLoading(false); }
  }, []);

  return { usuarios, roles, loading, cargarRoles, buscar, guardar, actualizar, cambiarEstado, eliminar };
};
